var map = {
	"./school-comp-medal-1-basic.png": 3586,
	"./school-comp-medal-2-basic.png": 3587,
	"./school-comp-medal-3-basic.png": 3588
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 701;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ranks .\.png*
// module id = 701
// module chunks = 0